import { render, staticRenderFns } from "./DynamicListResultPage.vue?vue&type=template&id=1526618a&scoped=true"
import script from "./DynamicListResultPage.vue?vue&type=script&lang=ts"
export * from "./DynamicListResultPage.vue?vue&type=script&lang=ts"
import style0 from "./DynamicListResultPage.vue?vue&type=style&index=0&id=1526618a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1526618a",
  null
  
)

export default component.exports